module.exports = __webpack_public_path__ + "static/media/02.5f4d6ab0.jpg";